import { teamPlannerSlice } from './slice';

export const {
  setStepsData,
  updateField,
  updateAllUnresolvedFields,
  addNewPlaceholder,
  togglePlaceholderModal,
  setSelectedProject,
  setSelectedStrategy,
  setSelectedStep,
  setPreviousStep,
  addSteps,
  removeStep,
  resetAllData,
  resetSteps,
  goToNextStepFailure,
  goToNextStepIdle,
  goToNextStepLoading,
  goToNextStepSuccess,
  goToNextStep,
  setFindTeamMemberStatus,
  setAssignAndAllocateStatus,
  addRowsWithUsersRemovedManually,
  removeRowsWithUsersRemovedManually,
  resetRowsWithUsersRemovedManually,
} = teamPlannerSlice.actions;

export const teamPlannerReducer = teamPlannerSlice.reducer;
